<div class="dialog-header">
  <div class="header-left">
    <h3>Companies Most Exposed to Stage {{ data.stage }} Technologies</h3>
    <span class="stage-badge" [style.background-color]="getStageColor(data.stage_name)">
      {{ data.stage_name }}
    </span>
  </div>
  <button mat-icon-button (click)="close()" class="close-btn">&times;</button>
</div>

<div class="dialog-body">
  <!-- Spinner -->
  <div class="d-flex justify-content-center my-4" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Error -->
  <div class="alert alert-danger" *ngIf="error">
    Failed to load stage companies data.
  </div>

  <!-- Table -->
  <div class="table-container" *ngIf="!loading && !error && firms.length">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Company Name</th>
          <th class="text-end">Exposure(12m)</th>
          <th class="text-end">Relative Exposure(12m,%)</th>
          <th class="text-end">Annual Return</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let firm of firms">
          <td>{{ firm.rank }}</td>
          <td>{{ firm.company_name }}</td>
          <td class="text-end">{{ firm.exposure | number:'1.0-0' }}</td>

          <td class="text-end">{{ firm.rel_exposure_pct | number:'1.0-1' }}</td>
          <td class="text-end" [class.text-success]="firm.annual_return_pct >= 0"
            [class.text-danger]="firm.annual_return_pct < 0">
            {{ firm.annual_return_pct >= 0.05 ? '+' : '' }}{{ firm.annual_return_pct | number:'1.1-1' }}%
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Empty -->
  <div class="text-center text-muted my-4" *ngIf="!loading && !error && !firms.length">
    No companies found for this stage.
  </div>
</div>